import { Component, Input } from '@angular/core';

@Component({
  selector: 'icon-outline',
  templateUrl: './icon-outline.component.html',
  styleUrls: []
})
export class IconOutlineComponent {
  @Input() icon: string;
}
